export const brandings = {
  MANULIFE: "MF",
  BERMUDA: "MLB",
  JOHN_HANCOCK: "JH",
  VITALITY: "JHV",
  DTC_PI: "JHDTCPI",
};

export const APP_TYPES = {
  NEW_UI: 'newUi',
  LTC: 'ltc',
  MANULIFE: 'manulife',
  AGENT_PORTAL: 'agentportal',
  MANULIFE_HONG_KONG: 'manulifeHongKong',
  JOHN_HANCOCK: 'johnHancock',
  JOHN_HANCOCK_GENERIC: 'johnHancockGeneric',
  VITALITY: 'vitality',
  SALESHUB: 'saleshub',
  DEFAULT: 'default'
};

export const appGroups = {
  SALESHUB_APPIDS: "27096401,10597976",
  BERMUDA_APPIDS: "27096404,27096464,27096465",
  GHNW_APPIDS: "27096464",
  VITALITY_APPIDS: "27096999,27096405",
  LTC_APPIDS: "266980,266981",
  PROVIDER_APPIDS: "266981",
  FACILITY_PROVIDER_APPIDS: "266980",
  PERSONIFY_APPIDS: "266978",
  ANNUITIES_APPIDS: "5137",
  SPRNT_APPIDS: "15482",
  DTC_PI_APPIDS: "2320147",
  B2B_PORTAL_APPIDS: "1106",
  CONTACT_HOURS_APP: "5137,27096999,266976,266977,266978,266980,266981,362772,17296",
  B2C_PORTAL_APPIDS: "1104",
  VPRO_APPIDS: "27097999",
  MY_PORTFOLIO_APPIDS: "27096410",
};

export const isUSRB2BPortal = (appid) =>
  appGroups.B2B_PORTAL_APPIDS.split(",").includes(appid);

export const isUpdatedPage = (appid) => {
    return appGroups.DTC_PI_APPIDS.split(",").includes(appid);
}

export const isUSRB2CPortal = (appid) =>
  appGroups.B2C_PORTAL_APPIDS.split(",").includes(appid);

export const isLTCApp = (appid) =>
  appGroups.LTC_APPIDS.split(",").includes(appid);

export const isProviderApp = (appid) =>
  appGroups.PROVIDER_APPIDS.split(",").includes(appid);

export const isPersonifyApp = (appid) =>
  appGroups.PERSONIFY_APPIDS.split(",").includes(appid);

export const isVitalityProApp = (appid) => {
  return appGroups.VPRO_APPIDS.split(",").includes(appid);
}

export const isMyPortfolioApp = (appid) => {
  return appGroups.MY_PORTFOLIO_APPIDS.split(",").includes(appid);
}

export const isNewUi = (appid) => {
  if (isUSRB2BPortal(appid) || isUSRB2CPortal(appid)) {
    return true;
  }

  if (
    appGroups.DTC_PI_APPIDS.split(",").includes(appid)
  ) {
    return true;
  }

  return false;
};

export const getAppGroupUrl = (appid) => {
  const APP_GROUP_URL_MAP = {
    B2B_PORTAL_APPIDS: process.env.REACT_APP_1106_LOGIN_URL,
    VPRO_APPIDS: process.env.REACT_APP_VPRO_APP_REDIRECT_URL,
  };

  return (
    Object.entries(APP_GROUP_URL_MAP).find(([groupName]) =>
      appGroups[groupName]?.split(",").includes(appid)
    )?.[1] || null
  );
};

export const showInfoPanel = (appid) => {
  if (appGroups.DTC_PI_APPIDS.split(",").includes(appid)) {
    return false;
  }

  return true;
}

export const showSideBar = (appid) => {
  if (appGroups.DTC_PI_APPIDS.split(",").includes(appid)) {
    return false;
  }

  return true;
}